// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Vuex
// Centralized State Management for Vue.js.
// https://github.com/vuejs/vuex
import Vuex from 'vuex'

// Vuex Persistedstate
// Persist and rehydrate your Vuex state between page reloads.
// https://github.com/robinvdvleuten/vuex-persistedstate
import createPersistedState from 'vuex-persistedstate'

// Modules
// https://vuex.vuejs.org/guide/modules.html
import login from './modules/login'
import status from './modules/status'
import SelecionaAplicacao from '@/store/modules/SelecionaAplicacao'
import menus from '@/constants/menus'

Vue.use(Vuex)
// Making sure that we're doing everything correctly by enabling
// strict mode in the dev environment.
// https://vuex.vuejs.org/guide/strict.html
const debug = process.env.NODE_ENV !== 'production'

// root state
const state = {
  apiPath: process.env.VUE_APP_ROOT_API,
  menus: [...menus],
  currentMenu: {},
  countEmbed: 0
}

// root getters
const getters = {
  apiPath: state => state.apiPath,
  menus: state => state.menus,
  currentMenu: state => state.currentMenu
}

// mutations
const mutations = {
  setCurrentMenu (state, menu) {
    state.currentMenu = menu || (this.menus[0])
  },
  addCountEmbed (state) {
    state.countEmbed += 1
  }
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    login,
    status,
    SelecionaAplicacao
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'key-painel-omnichannel',
      paths: ['login']
    })
  ]
})
